import { get, put, post, del } from 'redux/shelf/api';
import { createReducer } from 'redux/shelf/reducer';
import session from 'lib/session';

export const actions = {
  getTiers: get`merchant-tiers`(),
  createTier: post`merchant-tiers`(),
  updateTier: put`merchant-tiers:id`(),
  deleteTier: del`merchant-tiers/:id`(),
  updateMerchantTier:
    put`/merchants/${session.getMerchant}/settings/${session.getMerchant}/updateMerchantTier`(),
};

export const reducer = createReducer(actions, {
  [`${actions.getTiers}`]: (state, { payload: { tiers } }) => ({
    ...state,
    tiers,
  }),
  [`${actions.createTier}`]: (state, { payload: { tier } }) => ({
    ...state,
    tiers: [...state.tiers, tier],
  }),
  [`${actions.updateTier}`]: (state, { tier }) => ({
    ...state,
    tiers: state.tiers?.map((t) => (t.id === tier.id ? tier : t)),
  }),
  [`${actions.deleteTier}`]: (state, { tier }) => ({
    ...state,
    tiers: state.tiers?.filter((t) => t.id !== tier.id),
  }),
  [`${actions.updateMerchantTier}`]: (state, { tierId, tags }) => ({
    ...state,
    merchant: { tierId, tags },
  }),
});
